module.exports = __webpack_public_path__ + "img/image-order-status--5.636e3edc.png";